'use client';

import Image from 'next/image';

import v from 'voca';
import { Button } from '../../ui/Button';

export const Confirmation = ({
  handleCloseModal,
  section,
}: {
  handleCloseModal: () => void;
  section: string;
}) => {
  return (
    <div className="flex flex-col gap-10 items-center">
      <span className="">
        <Image
          src="/icons/sparkles.svg"
          alt="Confirmation"
          width={40}
          height={40}
          style={{ objectFit: 'contain' }}
        />
      </span>
      <h2 className="text-center text-3xl font-bold">
        {v.titleCase(section)} Complete
      </h2>
      <div className="flex flex-col gap-4 items-center">
        <span className="text-text-secondary max-w-[640px] text-center pb-5">
          You have successfully completed the {`'${v.titleCase(section)}'`}{' '}
          section.
        </span>
        <span className="w-[173px]">
          <Button text="Ok" variant="primary" onClick={handleCloseModal} />
        </span>
      </div>
      <Image
        src="/sra_complete.png"
        alt="Confirmation"
        width={1024}
        height={300}
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
};
